import { t } from '@lingui/core/macro';
import { Box, IconButton, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FloatingSidebarHeader } from './styled';
export function Header(props) {
    const { title, subtitle, actions, onClose } = props;
    const closeLabel = t({
        message: 'Close sidebar',
        comment: 'Floating sidebar - Close sidebar button label',
    });
    return (<FloatingSidebarHeader>
      <Box flexDirection="column">
        <Typography $fontSize="small" $fontWeight="semibold" $appearance="300" $truncate>
          {title}
        </Typography>
        {subtitle && (<Typography $fontSize="tiny" $appearance="200" $truncate>
            {subtitle}
          </Typography>)}
      </Box>

      <Box gap="sm" alignItems="center">
        {actions}

        <IconButton appearance="ghost" size="xs" aria-label={closeLabel} onClick={onClose}>
          <Falcon icon="xmark"/>
        </IconButton>
      </Box>
    </FloatingSidebarHeader>);
}
